<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.33398" y="3.33334" width="13.3333" height="13.3333" rx="2" stroke="#AC986A" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33398 8.33332H16.6673" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.33268 3.33334V16.6667" stroke="#AC986A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>